"use client";
import { useLocalStorage } from "hooks/useLocalStorage";
import { getRandomUUID } from "hooks/utils/randomizer";
import React, { createContext } from "react";

const CartContextProvider = ({ children }) => {
  const [cart, setCart] = useLocalStorage("gsfurn_cart", []); //TODO change gsfurn_cart to something unique for every multisite

  function addToCart(product) {
    const item_id = getRandomUUID();
    
    // Update quantity if product already in cart with same variation_id and preparation id (ignoring uuid) else add new item
    setCart((cart) => {
      const existingIndex = cart.findIndex(
        (item) =>
          item?.product_id === product?.product_id &&
          item?.variation_id === product?.variation_id &&
          item?.preparation === product?.preparation
      );

      if (existingIndex !== -1) {
        const new_cart = [...cart];
        new_cart[existingIndex].quantity += product?.quantity; // Increment quantity

        return new_cart;
      } else {
        return [...cart, { ...product, uuid: item_id }];
      }
    }
    );

    return item_id;
  }

  function removeFromCart(uuid) {
    setCart((cart) => cart.filter((product) => product.uuid !== uuid));
  }

  function clearCart() {
    setCart([]);
  }

  function updateCartItem(uuid, field, value) {
    setCart((cart) => {
      const new_cart = cart.map((product) =>
        product.uuid === uuid ? { ...product, [field]: value } : { ...product }
      );
      return new_cart;
    });
  }

  function updateCartItemQuantity(uuid, quantity) {
    let number = parseInt(quantity);
    if (isNaN(number)) {
      number = 1;
    }
    updateCartItem(uuid, "quantity", Math.max(1, number));
  }

  function updateCartItemPreparation(uuid, prepare_id) {
    updateCartItem(uuid, "preparation", prepare_id);
  }

  function getCart() {
    return cart;
  }

  const exportData = {
    useCart: getCart,
    getCart,
    useCartCount: () =>
      cart
        ? cart.reduce((total, item) => total + parseInt(item?.quantity), 0)
        : 0,
    addToCart,
    removeFromCart,
    updateCartItemPreparation,
    updateCartItemQuantity,
    updateCartItem,
    clearCart,
  };

  return (
    <CartContext.Provider value={exportData}>{children}</CartContext.Provider>
  );
};
export default CartContextProvider;
export const CartContext = createContext();
